import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import { Button } from 'src/components/buttons-and-actions/button';
import { NetworkPointSearch } from 'src/components/domain-specifics/network-points/network-point-search';
import type { LoadedAppShellData } from 'src/components/layout/app-shell/use-app-shell-data';
import { Container } from 'src/components/layout/container';
import {
  HeaderSecondaryBackground,
  HeaderSecondaryCenter,
} from 'src/components/layout/header/secondary-nav';
import { SecondaryNavDashboard } from 'src/components/layout/header/secondary-nav-dashboard';
import { SecondaryNavGdm } from 'src/components/layout/header/secondary-nav-gdm';
import { SecondaryNavH2 } from 'src/components/layout/header/secondary-nav-h2';
import { SecondaryNavLng } from 'src/components/layout/header/secondary-nav-lng';
import { SecondaryNavMarketMessages } from 'src/components/layout/header/secondary-nav-market-messages';
import { SecondaryNavReporting } from 'src/components/layout/header/secondary-nav-reporting';
import { SecondaryNavStorage } from 'src/components/layout/header/secondary-nav-storage';
import { SecondaryNavTransport } from 'src/components/layout/header/secondary-nav-transport';
import type { ActiveSection } from 'src/components/layout/header/types';
import type { MobileNavState } from 'src/components/layout/header/use-mobile-nav';
import { useBreakpoints } from 'src/hooks/use-breakpoints';

type HeaderSecondaryProps = {
  activeSection: ActiveSection;
  mobileNav: MobileNavState;
  appShellData: LoadedAppShellData;
};

export const HeaderSecondary: FC<HeaderSecondaryProps> = ({
  activeSection,
  mobileNav,
  appShellData,
}) => {
  const { minTablet } = useBreakpoints();

  const links = (
    <>
      <SecondaryNavDashboard
        activeSection={activeSection}
        appShellData={appShellData}
      />
      <SecondaryNavTransport activeSection={activeSection} />
      <SecondaryNavStorage
        activeSection={activeSection}
        appShellData={appShellData}
      />
      <SecondaryNavLng activeSection={activeSection} />
      <SecondaryNavH2 activeSection={activeSection} />
      <SecondaryNavReporting
        activeSection={activeSection}
        appShellData={appShellData}
      />
      <SecondaryNavGdm activeSection={activeSection} />
      <SecondaryNavMarketMessages activeSection={activeSection} />
    </>
  );
  return (
    <HeaderSecondaryBackground>
      <Container>
        <HeaderSecondaryCenter>
          <div
            className={`
              flex animate-fade-in grid-flow-col items-center justify-between
              gap-2xl
            `}
          >
            <div>{minTablet && links}</div>

            {minTablet ? (
              <div
                className="shrink-0" // safari fix (UXX-151)
              >
                <NetworkPointSearch />
              </div>
            ) : (
              <Button
                mode="inverse"
                onClick={() =>
                  mobileNav.setValue(
                    mobileNav.value === 'secondary' ? null : 'secondary'
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faBars}
                  aria-label="Toggle secondary navigation"
                />
              </Button>
            )}
          </div>
        </HeaderSecondaryCenter>
      </Container>

      {!minTablet && mobileNav.value === 'secondary' && (
        <div className="grid border-t">
          <div onClick={() => mobileNav.setValue(null)}>{links}</div>
          <NetworkPointSearch />
        </div>
      )}
    </HeaderSecondaryBackground>
  );
};
